exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".topicNum{position:absolute;top:100px;right:100px}.gray{color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-eacd4a2a!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/topic/topicDetail.vue
// module id = 641
// module chunks = 0